/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShivaGNVertPublicConfiguration, ShivaGNVertPublicConfigurationParams } from './shiva-gn-vert-public-configuration';

import { OnboardingSubscriptionService } from './services/onboarding-subscription.service';
import { OnboardingService } from './services/onboarding.service';
import { StationGnvService } from './services/station-gnv.service';
import { PriceService } from './services/price.service';
import { FilesStorageService } from './services/files-storage.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    OnboardingSubscriptionService,
    OnboardingService,
    StationGnvService,
    PriceService,
    FilesStorageService,
    ShivaGNVertPublicConfiguration
  ],
})
export class ShivaGNVertPublicModule {
  static forRoot(params: ShivaGNVertPublicConfigurationParams): ModuleWithProviders<ShivaGNVertPublicModule> {
    return {
      ngModule: ShivaGNVertPublicModule,
      providers: [
        {
          provide: ShivaGNVertPublicConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ShivaGNVertPublicModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ShivaGNVertPublicModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
